import React from "react";
import Select from "react-select";

const CustomSelect = ({
  options,
  onChange,
  value,
  onBlur,
  ref,
  placeholder,
}) => {
  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "10px",
      backgroundColor: "#F5F6FA",
      padding: "5px",
      borderColor: "#f0f0f0", // Light border color
      boxShadow: "none",
      "&:hover": {
        borderColor: "#dcdcdc",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
      backgroundColor: state.isFocused ? "#F5F6FA" : null,
      padding: "8px",
      color: "#000",
    }),
    singleValue: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "10px",
      padding: "5px",
    }),
  };

  const formatOptionLabel = ({ label, color }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <span
        style={{
          display: "inline-block",
          width: 16,
          height: 16,
          borderRadius: "4px",
          backgroundColor: color,
          marginRight: 8,
        }}
      />
      {label}
    </div>
  );

  return (
    <Select
      options={options}
      styles={customStyles}
      formatOptionLabel={formatOptionLabel}
      placeholder={placeholder}
      onChange={(selectedOption) => {
        // Call onChange prop with the selected value
        onChange(selectedOption ? selectedOption.value : null);
      }}
      value={options.find((option) => option.value === value) || null} // Set the selected value
      onBlur={onBlur} // Handle blur if necessary
      ref={ref} // Pass ref to the component
    />
  );
};

export default CustomSelect;
